import React, { useState } from 'react';
import { isValidEmail } from '../../../lib/utils.js';
import GroupItem from './GroupItem.jsx';

const GroupsTree = ({ isActionDisabled, ...rest }) => {
  const { groupsTree, setEditableId, onSaveNodeFieldsChanges } = rest;

  const [manuallyFieldError, setManuallyFieldError] = useState({});

  const onSaveChanges = (id, prevState, currState) => {
    const hasNameErrors = !currState.name;
    const hasEmailErrors = currState.email && !isValidEmail(currState.email);

    if (hasNameErrors) {
      setManuallyFieldError({ [`name${id}`]: 'Name is required' });
    } else if (hasEmailErrors) {
      setManuallyFieldError({ [`email${id}`]: 'Invalid email format.' });
    } else {
      onSaveNodeFieldsChanges(prevState, {
        ...prevState,
        name: currState.name,
        email: currState.email,
        parentId: currState.parentId,
        parentGroupName: '',
      });
    }
  };

  return groupsTree.map((group, index) => (
    <React.Fragment key={group.id}>
      <GroupItem
        group={group}
        index={index}
        padding={false}
        isActionDisabled={isActionDisabled}
        setEditableId={setEditableId}
        onSaveChanges={onSaveChanges}
        manuallyFieldError={manuallyFieldError}
        setManuallyFieldError={setManuallyFieldError}
        {...rest}
      />
    </React.Fragment>
  ));
};

export default GroupsTree;
